'use strict'

const { statusVendor } = require('./../../lib/viewLib')

const vendor = {
  namespaced: true,

  state: {
    id: -999,
    name: '',
    status: 'N'
  },

  getters: {
    venId: state => state.id,
    venName: state => state.name,
    venStatus: state => state.status,    
    regVisible: state => state.status === 'N' || state.status === 'V',
    venStatusCol: state => statusVendor.find(el => el.status === state.status).color,
    venStatusColText: state => statusVendor.find(el => el.status === state.status).text,
    venStatusCaption: state => statusVendor.find(el => el.status === state.status).caption
  },

  mutations: {
    setId: function(state, id) {
      state.id = id
    },
    setName: function(state, name) {
      state.name = name
    },
    setStatus: function(state, status) {
      state.status = status
    }
  },

  actions: {
    assignVendor: function(context, ven) {
      context.commit('setId', ven.id)
      context.commit('setName', ven.name)
      context.commit('setStatus', ven.status)
    },
    releaseVendor: function(context) {
      context.commit('setId', -999)
      context.commit('setName', '')
      context.commit('setStatus', 'N')
    }
  }
}

export default vendor